// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__pBVpB","header__wrapper":"style_header__wrapper__JTVJC","header-logo":"style_header-logo__uZOOm","header__code":"style_header__code__DIXjj"};